var exports = {
  "J": "xfb577c5e--d0bf9f--list-collapse",
  "x": "xfb577c5e--d0bf9f--list-item",
};

module.exports = exports;
